import { render, staticRenderFns } from "./LeadCategoryIcon.vue?vue&type=template&id=4d0edcd7&scoped=true"
import script from "./LeadCategoryIcon.vue?vue&type=script&lang=js"
export * from "./LeadCategoryIcon.vue?vue&type=script&lang=js"
import style0 from "./LeadCategoryIcon.vue?vue&type=style&index=0&id=4d0edcd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0edcd7",
  null
  
)

export default component.exports